export const SUBMITTER_FIRST_NAME_QUESTION_TAG = "submitterFirstName"
export const SUBMITTER_FULL_NAME_QUESTION_TAG = "submitterFullName"
export const SUBMITTER_LAST_NAME_QUESTION_TAG = "submitterLastName"

export const SUBMITTER_QUESTION_TAGS = [
  SUBMITTER_FIRST_NAME_QUESTION_TAG,
  SUBMITTER_FULL_NAME_QUESTION_TAG,
  SUBMITTER_LAST_NAME_QUESTION_TAG,
]
